export const BREAKPOINTS = {
  XS: 0,
  SM: 600,
  MD: 900,
  LG: 1170,
  XL: 1536,
}